/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/right-black': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="#fff" d="M0 0h34v34H0z"/><path pid="1" d="M27 14.72L18.55 5.5h-4.78l6.76 7.38H7v3.69h13.53L13.77 24h4.78z" _fill="#151716"/><path pid="2" _fill="#151716" d="M7 13.62h4V28.5H7z"/></g></g>'
  }
})
